import { notifyError } from "src/assets/toastService";

export function compressImage(file: File, onSuccess: (file: File, preview: string) => void) {
  const img = new Image();
  const reader = new FileReader();

  reader.onload = () => {
    if (typeof reader.result === "string") img.src = reader.result;
  };

  img.onload = () => {
    const canvas = document.createElement("canvas");
    const maxWidth = 150;
    const scale = maxWidth / img.width;
    canvas.width = maxWidth;
    canvas.height = img.height * scale;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    canvas.toBlob((blob) => {
      if (blob && blob.size <= 160 * 1024) {
        const compressed = new File([blob], "image.png", { type: "image/png" });
        onSuccess(compressed, URL.createObjectURL(compressed));
      } else {
        notifyError("Image must be under 100KB");
      }
    }, "image/png");
  };

  reader.readAsDataURL(file);
}
